/**
 * MobileMenu — the native app's "more / settings" list, shown on the Profile
 * (account hub) screen. On native we hide the webby sidebar/hamburger and
 * navigate via the bottom tabs; this grouped list is the home for the
 * secondary destinations that aren't tabs, plus Sign out.
 *
 * Styled as a native settings list (grouped rows, chevrons, tap states).
 */
import { useNavigate, NavLink } from 'react-router-dom'
import { useAuthStore } from '../../stores/auth.js'

function getRole(token) {
  try { return JSON.parse(atob(token.split('.')[1])).role } catch { return 'user' }
}

const Chevron = (
  <svg className="mobile-menu__chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="9 18 15 12 9 6" />
  </svg>
)

const ITEMS = [
  { to: '/journey',   label: 'My Journey',    sub: 'Open quests in your tree' },
  { to: '/world-map', label: 'World Map',     sub: 'Where the archive reaches' },
  { to: '/help',      label: 'How it works',  sub: 'Guide & FAQ' },
]

export default function MobileMenu() {
  const { token, logout } = useAuthStore()
  const navigate = useNavigate()
  const isAdmin = token && getRole(token) === 'admin'

  function signOut() {
    logout()
    navigate('/login')
  }

  return (
    <div className="mobile-menu">
      <div className="mobile-menu__group">
        {ITEMS.map(i => (
          <NavLink key={i.to} to={i.to} className="mobile-menu__row">
            <span className="mobile-menu__text">
              <span className="mobile-menu__label">{i.label}</span>
              <span className="mobile-menu__sub">{i.sub}</span>
            </span>
            {Chevron}
          </NavLink>
        ))}
        {isAdmin && (
          <NavLink to="/admin" className="mobile-menu__row">
            <span className="mobile-menu__text">
              <span className="mobile-menu__label">Admin</span>
            </span>
            {Chevron}
          </NavLink>
        )}
      </div>

      <div className="mobile-menu__group">
        <button className="mobile-menu__row mobile-menu__row--button" onClick={signOut}>
          <span className="mobile-menu__label">Sign out</span>
        </button>
      </div>
    </div>
  )
}
